// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1HSZl","paramInput":"JobSimulator_paramInput__1_fB6","input":"JobSimulator_input__10Ydx"};